import { api } from '../commonApi';
import { ICreateMenuRequest, IGetMenuResponse } from '../../proto/menu/menu';
import { ICreateCategoryRequest, IGetCategoryResponse } from '../../proto/category/category';

export const BASE_MENU_URL = `/menu`;
export const BASE_MENU_CATEGORY_URL = `category`;

export const menuApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getActiveMenu: builder.query<IGetMenuResponse, void>({
			query: () => `${BASE_MENU_URL}/active`,
		}),
		getMenus: builder.query<IGetMenuResponse[], void>({
			query: () => `${BASE_MENU_URL}`,
			providesTags: ['Menus'],
		}),
		getMenuById: builder.query<IGetMenuResponse, string>({
			query: (id) => `${BASE_MENU_URL}/${id}`,
			providesTags: (res, _, id) => [{ type: 'Menus', id }],
		}),
		deleteMenu: builder.mutation<void, string>({
			query: (id) => ({
				url: `${BASE_MENU_URL}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: () => ['Menus'],
		}),
		initMenu: builder.mutation<IGetMenuResponse, void>({
			query: () => ({
				url: `${BASE_MENU_URL}/init`,
				method: 'POST',
			}),
			invalidatesTags: () => ['Menus'],
		}),
		updateMenu: builder.mutation<IGetMenuResponse, ICreateMenuRequest & { id: string }>({
			query: ({ id, ...body }) => ({
				url: `${BASE_MENU_URL}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: (res, error, { id }) => [{ type: 'Menus', id }],
		}),
		createCategory: builder.mutation<IGetCategoryResponse, ICreateCategoryRequest & { menuId: string }>({
			query: ({ menuId, ...body }) => ({
				url: `${BASE_MENU_URL}/${menuId}/${BASE_MENU_CATEGORY_URL}`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (res, _, { menuId }) => [
				{ type: 'MenuCategory', id: res.id },
				{ type: 'Menus', id: menuId },
			],
		}),
		updateCategory: builder.mutation<IGetCategoryResponse, ICreateCategoryRequest & { menuId: string; categoryId: string }>({
			query: ({ menuId, categoryId, ...body }) => ({
				url: `${BASE_MENU_URL}/${menuId}/${BASE_MENU_CATEGORY_URL}/${categoryId}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: (result, error, { menuId, categoryId }) => [
				{ type: 'MenuCategory', id: categoryId },
				{ type: 'Menus', id: menuId },
			],
		}),
		getCategoryById: builder.query<IGetCategoryResponse, { menuId: string; categoryId: string }>({
			query: ({ menuId, categoryId }) => `${BASE_MENU_URL}/${menuId}/${BASE_MENU_CATEGORY_URL}/${categoryId}`,
			providesTags: (res, _, { categoryId }) => [{ type: 'MenuCategory', id: categoryId }],
		}),
	}),
});

export const {
	useGetActiveMenuQuery,
	useGetMenuByIdQuery,
	useGetMenusQuery,
	useDeleteMenuMutation,
	useUpdateMenuMutation,
	useInitMenuMutation,
	useCreateCategoryMutation,
	useGetCategoryByIdQuery,
	useUpdateCategoryMutation,
} = menuApi;
